<template>
  <div>
    <div v-if="queueLoading">
      {{ $t("bodyprint_queue.bodyprint_table.loading") }}
    </div>
    <div v-else>
      <div v-if="queueItems.length === 0">
        {{ $t("bodyprint_queue.bodyprint_table.no_data") }}
      </div>
      <div v-else>
        <b>{{ $t("bodyprint_queue.bodyprint_table.title") }}</b>

        <table
          class="table-fixed w-full border-solid px-4 mt-3 data-table-right-section overflow-y-auto"
        >
          <thead>
            <tr>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_queue.bodyprint_table.headers.retailer_code") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_queue.bodyprint_table.headers.retailer") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_queue.bodyprint_table.headers.created_at") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_queue.bodyprint_table.headers.last_updated_at") }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(queueItem, index) in queueItems"
              :key="index"
              @click="handleQueueItemClick(queueItem)"
              v-bind:class="[
                'cursor-pointer hover:bg-gray-50',
                selectedQueueItem && selectedQueueItem.id === queueItem.id
                  ? 'font-bold'
                  : 'font-normal',
                index === queueItems.length - 1 ? '' : 'border-b'
              ]"
            >
              <td class="py-3 px-2 text-left text-sm">
                {{ queueItem.retailer_code }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ queueItem.retailer_name }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ formatDate(queueItem.created_at) }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ formatDate(queueItem.last_updated_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BodyPrintQueueTable",
  props: {
    queueItems: {
      type: Array,
      default: () => []
    },
    queueLoading: {
      type: Boolean,
      default: false
    },
    selectedQueueItem: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleQueueItemClick(queueItem) {
      this.$emit("queue-item-selected", queueItem);
    },
    formatDate(date) {
      return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
    }
  }
};
</script>
